import { Component, OnInit } from '@angular/core';
import { DashboardService } from '@teem/services/dashboard.service';


@Component({
	selector: 'top-customers',
	templateUrl: './top-customers-table.component.html',
	styleUrls: ['./top-customers-table.component.scss']
})
export class TopCustomersTableComponent implements OnInit {
	users: any = [];
	
	// users = [
	// 	{ name: 'John Doe', email: 'johndoe@gmail.com', earnings: 5903.3 },
	// 	{ name: 'John Doe', email: 'johndoe@gmail.com', earnings: 5903.3 },
	// 	{ name: 'John Doe', email: 'johndoe@gmail.com', earnings: 5903.3 },
	// 	{ name: 'John Doe', email: 'johndoe@gmail.com', earnings: 5903.3 },
	// 	{ name: 'John Doe', email: 'johndoe@gmail.com', earnings: 5903.3 }
	// ];

	constructor(
		private dashboardService: DashboardService,
	) {

	}

	ngOnInit(): void {
		this.getTopCustomers();
	}

	getTopCustomers() {
		this.users = [];

		this.dashboardService.getTopCustomers().subscribe((response: any = []) => {
			console.log(response)
			this.users = response;
		});
	}
}
